export const revampedNavigation = 'navigation_cookie';   
export const showStoresInInterstitial = 'interstitial';
export const interstitialMileStoneCount = 'interstitial_milestone';
export const interstitialParam = 'referrer=interstitial';
